import { render } from "./controlPanel.vue?vue&type=template&id=9dda8510&scoped=true"
import script from "./controlPanel.vue?vue&type=script&lang=js"
export * from "./controlPanel.vue?vue&type=script&lang=js"

import "./controlPanel.vue?vue&type=style&index=0&id=9dda8510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dda8510"]])

export default __exports__